import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';

const CustomerCard =(props)=>{
return(
    <>
    <div className="reviewcard-style">
        <h4>{props.name}</h4>
        <div>
        <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
        <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
        <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
        <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
        <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
        </div>
        <p>{props.date}</p>
        <p className="client-review">{props.review}</p>
    </div>
    
    
    
    </>
);
}


export  default CustomerCard;